// src/themes/index.js
import dayOverrides from "./light/day.js";
import karafarinOverrides from "./light/karafarin.js";
import isatisOverrides from "./light/isatis.js";
import sarmadOverrides from "./light/sarmad.js";
import novinOverrides from "./light/novin.js";
import sharedDark from "./dark.js";

const companyLightThemes = {
  day: { ...dayOverrides },
  karafarin: { ...karafarinOverrides },
  isatis: { ...isatisOverrides },
  sarmad: { ...sarmadOverrides },
  novin: { ...novinOverrides },
};

export function applyGlobalTheme(vuetifyInstance, company = "day") {
  if (!vuetifyInstance?.theme?.themes) {
    console.warn("[Theme] Vuetify not ready yet - skipping");
    return;
  }

  const root = document.documentElement;
  const isDark = !!vuetifyInstance.theme.dark;

  clearThemeVars();

  const palette = isDark
    ? { ...sharedDark }
    : companyLightThemes[company] || companyLightThemes.day;

  // اعمال به Vuetify با حفظ تم پایه
  const themeName = isDark ? "dark" : "light";
  vuetifyInstance.theme.themes[themeName] = {
    ...vuetifyInstance.theme.themes[themeName],
    ...palette,
  };

  // CSS Variables
  Object.keys(palette).forEach((key) => {
    const value = palette[key];
    if (value == null) return;

    const lower = key.toLowerCase();
    root.style.setProperty(`--abr-${lower}`, value);
    root.style.setProperty(`--abr-${key}`, value);

    if (key === "gradientStart")
      root.style.setProperty("--abr-gradient-start", value);
    if (key === "gradientEnd")
      root.style.setProperty("--abr-gradient-end", value);
  });

  // RGB برای استفاده در rgba()
  ["P1", "BG1", "BG2", "BG3", "G1", "G2", "G3", "G4"].forEach((key) => {
    if (palette[key]) {
      const rgb = hexToRgb(palette[key]);
      if (rgb) {
        root.style.setProperty(
          `--abr-${key.toLowerCase()}-rgb`,
          `${rgb.r}, ${rgb.g}, ${rgb.b}`,
        );
      }
    }
  });

  root.classList.toggle("theme--dark", isDark);
  root.classList.toggle("theme--light", !isDark);

  console.log(
    `✅ Theme Applied: ${isDark ? "Dark" : "Light"} | Company: ${company}`,
  );
}

function hexToRgb(hex) {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result
    ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16),
      }
    : null;
}

function clearThemeVars() {
  const root = document.documentElement;
  Array.from(root.style)
    .filter((v) => v.startsWith("--abr-"))
    .forEach((v) => root.style.removeProperty(v));
}

// برای دسترسی جهانی (در main.js)
window.applyGlobalTheme = applyGlobalTheme;
